var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-primary flex items-center justify-center min-h-screen"},[_c('div',{staticClass:"flex flex-col gap-4 items-center"},[_c('AppLoading',{staticClass:"flex-shrink-0 w-24 h-24"}),_vm._v(" "),_c('div',{staticClass:"text-white font-bold text-xl"},[_vm._v("\n      Finding the best offer...\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }